/* eslint-disable no-console, max-classes-per-file*/ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
export var StorageKey;
(function(StorageKey) {
    StorageKey["NULL_KEY"] = "NULL_KEY";
    StorageKey["KAGGLE_THEME"] = "KAGGLE_THEME";
    StorageKey["KAGGLE_EDITOR"] = "KAGGLE_EDITOR";
    StorageKey["KAGGLE_EDITOR_CENTERED_LAYOUT_MODE"] = "KAGGLE_EDITOR_CENTERED_LAYOUT_MODE";
    StorageKey["KAGGLE_LANGUAGE_ID"] = "KAGGLE_LANGUAGE_ID";
    StorageKey["KAGGLE_LOCAL_STATE"] = "KAGGLE_LOCAL_STATE";
    StorageKey["KAGGLE_TEST_KEY"] = "KAGGLE_TEST_KEY";
    StorageKey["KAGGLE_CORGI_MODE"] = "KAGGLE_CORGI_MODE";
    StorageKey["KAGGLE_KITTY_MODE"] = "KAGGLE_KITTY_MODE";
    StorageKey["NUDGE_KEY_GPU_50PCT"] = "KAGGLE_NUDGE_KEY_GPU_50PCT";
    StorageKey["NUDGE_KEY_GPU_90PCT"] = "KAGGLE_NUDGE_KEY_GPU_90PCT";
    StorageKey["NUDGE_KEY_RAM_90PCT"] = "KAGGLE_NUDGE_KEY_RAM_90PCT";
    StorageKey["NUDGE_KEY_DISK_90PCT"] = "KAGGLE_NUDGE_KEY_DISK_90PCT";
    StorageKey["NUDGE_KEY_IPYNB_DOWNLOAD"] = "KAGGLE_NUDGE_KEY_IPYNB_DOWNLOAD";
    StorageKey["NUDGE_KEY_COMMONLY_EXPORTED_NOTEBOOK"] = "KAGGLE_NUDGE_KEY_COMMONLY_EXPORTED_NOTEBOOK";
    StorageKey["NUDGE_KEY_EMPLOYER"] = "KAGGLE_NUDGE_KEY_EMPLOYER" /** @deprecated */ ;
    StorageKey["NUDGE_KEY_COMMUNITY_ALL"] = "KAGGLE_NUDGE_KEY_COMMUNITY_ALL";
    StorageKey["NUDGE_KEY_COMMUNITY_ALL_SEEN"] = "KAGGLE_NUDGE_KEY_COMMUNITY_ALL_SEEN";
    StorageKey["NOTIFICATIONS"] = "NOTIFICATIONS";
    StorageKey["RECENTLY_EDITED_ITEMS"] = "KAGGLE_RECENTLY_EDITED_ITEMS";
    StorageKey["RECENTLY_VIEWED_ITEMS"] = "KAGGLE_RECENTLY_VIEWED_ITEMS";
    StorageKey["RECENT_BOOKMARKS"] = "KAGGLE_RECENT_BOOKMARKS";
    StorageKey["EMERGENCY_ALERT_BANNERS_DISMISSED"] = "KAGGLE_EMERGENCY_ALERT_BANNERS";
    StorageKey["NAV_USER_MENUS_OPEN"] = "KAGGLE_NAV_USER_MENUS_OPEN";
    StorageKey["ONBOARDING_PANEL"] = "KAGGLE_ONBOARDING_PANEL";
    StorageKey["EMOJI_SKIN_TONE"] = "KAGGLE_EMOJI_SKIN_TONE_PREFERENCE";
})(StorageKey || (StorageKey = {}));
var JUPYTER_ORIGINS = [
    "http://localhost:5000",
    "https://staging.kaggleusercontent.com",
    "https://www.kaggleusercontent.com", 
];
// TODO(cochamberlain): Jupyter frame is attempting to call some of these on Redux initialization.
// Adding this as temporary fix to stop it from throwing errors and return uninitialized states.
// Longer term fix will be provided as follow up PR that stops Jupyter from trying to interact with storageClient.
var IS_JUPYTER = !window.location.origin || JUPYTER_ORIGINS.includes(window.location.origin);
export var isLocalStorageAvailable = function() {
    var success;
    try {
        var storage = window.localStorage;
        success = !!storage;
    } catch (e) {
        success = false;
    }
    return success;
};
export var isSessionStorageAvailable = function() {
    var success;
    try {
        var storage = window.sessionStorage;
        success = !!storage;
    } catch (e) {
        success = false;
    }
    return success;
};
export var StorageClient = /*#__PURE__*/ function() {
    "use strict";
    function StorageClient() {
        _classCallCheck(this, StorageClient);
        this.storage = null;
    }
    var _proto = StorageClient.prototype;
    _proto.delete = function _delete(key) {
        var ref;
        (ref = this.storage) === null || ref === void 0 ? void 0 : ref.removeItem(key);
    };
    /**
   * read storage setting. If local storage is not available or this is
   * read inside jupyter frame, return null.
   */ _proto.read = function read(key) {
        var ref;
        var ref1;
        return (ref1 = (ref = this.storage) === null || ref === void 0 ? void 0 : ref.getItem(key)) !== null && ref1 !== void 0 ? ref1 : null;
    };
    _proto.write = function write(key, value) {
        var ref;
        (ref = this.storage) === null || ref === void 0 ? void 0 : ref.setItem(key, value);
    };
    return StorageClient;
}();
export var SessionStorageClient = /*#__PURE__*/ function(StorageClient) {
    "use strict";
    _inherits(SessionStorageClient, StorageClient);
    var _super = _createSuper(SessionStorageClient);
    function SessionStorageClient() {
        _classCallCheck(this, SessionStorageClient);
        var _this;
        _this = _super.call(this);
        if (!IS_JUPYTER && isSessionStorageAvailable()) {
            _this.storage = window.sessionStorage;
        }
        return _this;
    }
    return SessionStorageClient;
}(StorageClient);
/**
 * Event listeners only work on `localStorage`, so the `subscribe` method
 * is only defined for this class.
 */ export var LocalStorageClient = /*#__PURE__*/ function(StorageClient) {
    "use strict";
    _inherits(LocalStorageClient, StorageClient);
    var _super = _createSuper(LocalStorageClient);
    function LocalStorageClient() {
        _classCallCheck(this, LocalStorageClient);
        var _this;
        _this = _super.call(this);
        /** Handler that gets called when localStorage changes occur in other tabs. */ _this.storageEventHandler = function(e) {
            var key = e.key;
            if (key) {
                var ref;
                (ref = _this.storageCallbacks.get(key)) === null || ref === void 0 ? void 0 : ref.forEach(function(callback) {
                    callback(key, e.newValue);
                });
            }
        };
        if (!IS_JUPYTER && isLocalStorageAvailable()) {
            _this.storage = window.localStorage;
        }
        _this.storageCallbacks = new Map();
        return _this;
    }
    var _proto = LocalStorageClient.prototype;
    _proto.subscribe = function subscribe(key, callback) {
        var _this = this;
        if (this.storage === null) {
            return function() {
                console.warn("key ".concat(key, " was never subscribed to in Jupyter frame."));
            };
        }
        // If this is the first being added, set up the storage change listener.
        // This will notify only when other tabs update this state.
        if (this.storageCallbacks.size === 0) {
            window.addEventListener("storage", this.storageEventHandler);
        }
        if (!this.storageCallbacks.has(key)) {
            this.storageCallbacks.set(key, new Set());
        }
        this.storageCallbacks.get(key).add(callback);
        // Return unsubscriber.
        return function() {
            var cbSet = _this.storageCallbacks.get(key);
            if (cbSet) {
                cbSet.delete(callback);
                if (cbSet.size === 0) {
                    _this.storageCallbacks.delete(key);
                    if (_this.storageCallbacks.size === 0) {
                        window.removeEventListener("storage", _this.storageEventHandler);
                    }
                }
            }
        };
    };
    return LocalStorageClient;
}(StorageClient);
export var storageClient = new LocalStorageClient();
